import { ViewHeading as ViewHeadingUI, ViewHeadingProps as ViewHeadingUIProps } from '@mews-distributor/ui';

import { DateHeading } from '../DateHeading';

export interface ViewHeadingProps extends Exclude<ViewHeadingUIProps, 'children'> {
    showDateHeading?: boolean;
}

export const ViewHeading = ({ showDateHeading = false, ...other }: ViewHeadingProps) => (
    <ViewHeadingUI {...other}>{showDateHeading ? <DateHeading /> : null}</ViewHeadingUI>
);
